import { gql } from "@apollo/client";

export const GET_THEMES_INTEREST = gql`
  query GetThemesOfInterest($page: Int, $pageSize: Int) {
    getThemesOfInterest(page: $page, pageSize: $pageSize) {
      message
      data {
        id
        image
        title
        description
        url
      }
      meta {
        page
        pageCount
        pageSize
        total
      }
    }
  }
`;
